module.exports = __webpack_public_path__ + "media/images/iconRight__accent--dark-fe4c1a3e1dd2144e656d1feba5f3c24e.png";